import { render, staticRenderFns } from "./CustomersOffstate.vue?vue&type=template&id=a6e755a4&scoped=true"
import script from "./CustomersOffstate.vue?vue&type=script&lang=js"
export * from "./CustomersOffstate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6e755a4",
  null
  
)

export default component.exports